const LIVE_TOOLTIP = "Ceci est l'aperçu (environnement de test) : ses données sont séparées du site en ligne. Cliquez pour ouvrir le vrai site.";

/** Badge visible uniquement sur l'environnement d'aperçu, pour ne jamais le confondre avec le site en ligne. */
export function PreviewBadge() {
  const host = window.location.hostname;
  const isPreview = host.includes("preview.emergentagent.com") || host === "localhost";
  if (!isPreview) return null;

  const liveHost = host.replace(".preview.emergentagent.com", ".emergent.host");
  const pill = (
    <span className="inline-flex items-center gap-2 bg-gold text-ink px-3 py-1.5 rounded-full font-mono text-[10px] uppercase tracking-[0.12em] shadow-lg border border-ink/20">
      <span className="w-1.5 h-1.5 rounded-full bg-ink animate-pulse" />
      Aperçu · données de test
    </span>
  );

  return (
    <div data-testid="preview-badge" className="fixed bottom-3 left-3 z-[100]">
      {liveHost !== host ? (
        <a href={`https://${liveHost}`} target="_blank" rel="noopener noreferrer" title={LIVE_TOOLTIP}
          className="hover:opacity-85 transition-opacity">
          {pill}
        </a>
      ) : (
        <span title="Environnement d'aperçu (données de test)">{pill}</span>
      )}
    </div>
  );
}
